module.exports = __webpack_public_path__ + "static/media/9.43f90ecd.png";